import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='sustainability-impact-financial-access-intro'
    moduleName='intro-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          align='center'
          nextElement='typography'>
          Helping Americans achieve <WidowBlock>financial security</WidowBlock>
        </Typography>
        <Typography disableBottomPadding>
          We exist to free Americans from financial anxiety. Every day, our solutions enable policyowners and clients to protect what they&#39;ve worked so hard for and grow their wealth. We&#39;re dedicated to expanding financial access in underserved communities, reducing the wealth gap, and empowering economic growth by helping build generational wealth.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
